// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-I":"I_power-ocean-collection-I__SoDb6"};